import { Directive, HostListener, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DeviceDimensionsService {
  scrHeight: any;
  scrWidth: any;
  deviceType: any;
  constructor() {
    window.addEventListener('resize', this.onResize.bind(this));
  }


  onResize(event) {
    this.scrHeight = window.innerHeight;
    this.scrWidth = window.innerWidth;

    if (this.scrWidth <= 768) {
      this.deviceType = 'small';   // For mobile devices
    } else if (this.scrWidth > 768 && this.scrWidth <= 1024) {
      this.deviceType = 'medium';   // For Tablet
    } else {
      this.deviceType = 'large';   // For monitor
    }

    return this.deviceType;
  }

}